import React from "react";
import {Button} from "../../UI/Button";
import {UserRemovalModal} from "../UserRemovalModal";
import {useModalContext} from "../../contexts/ModalContext/context";

export interface UserRemoveButtonProps {
    name: string;
    userId: string;
    onSuccess?: () => void;
}

export const UserRemoveButton: React.FC<UserRemoveButtonProps> = ({name, userId, onSuccess}) => {
    const { setIsOpen } = useModalContext();

    const handleRemoveClick = () => {
        setIsOpen(true);
    };

    return <>
        <Button appearance="danger" onClick={handleRemoveClick}>
            Delete User
        </Button>
        <UserRemovalModal name={name} userId={userId} onSuccess={onSuccess}/>
    </>;
};